import LoginRedirect from "./login-redirect";
export default LoginRedirect;